import { Translation } from '../types';

export const sk: Translation = {
  common: {
    loading: 'Načítava sa...',
    error: 'Chyba',
    cancel: 'Zrušiť',
    save: 'Uložiť',
    close: 'Zavrieť',
    search: 'Hľadať',
    reload: 'Obnoviť',
    logout: 'Odhlásiť sa',
    dashboard: 'Prehľad',
    products: 'Produkty',
    settings: 'Nastavenia',
    language: 'Jazyk',
    businessHours: 'Otváracie hodiny',
    back: 'Späť',
    selectAll: 'Vybrať všetko',
    deselectAll: 'Zrušiť výber',
    success: 'Úspech',
    selected: 'Vybrané',
    confirm: 'Potvrdiť',
    required: 'Povinné',
    requiredMarker: '*',
    previous: 'Predchádzajúce',
    next: 'Ďalšie',
    allRightsReserved: 'Všetky práva vyhradené.',
  },
  auth: {
    login: 'Prihlásenie',
    email: 'E-mailová adresa',
    password: 'Heslo',
    loginButton: 'Prihlásiť sa',
    loggingIn: 'Prihlasovanie...',
    loginSuccess: 'Prihlásenie úspešné',
    loginError: 'Nesprávny e-mail alebo heslo',
    invalidEmail: 'Zadajte platnú e-mailovú adresu',
    requiredFields: 'Zadajte e-mail a heslo',
    demoAccount: 'Demo účet:',
    loginDescription: 'Zadajte svoje prihlasovacie údaje',
    welcomeMessage: 'Vitajte v objednávkovom systéme pre firmy',
    // Registration
    register: 'Registrácia',
    createAccount: 'Vytvoriť účet',
    confirmPassword: 'Potvrdenie hesla',
    passwordRequirements: 'Heslo musí mať aspoň 8 znakov, obsahovať veľké a malé písmená, číslicu a špeciálny znak',
    passwordsDoNotMatch: 'Heslá sa nezhodujú',
    registrationSuccess: 'Registrácia úspešná',
    registrationDescription: 'Zaregistrujte si firemný účet',
    alreadyHaveAccount: 'Máte už účet?',
    signIn: 'Prihlásiť sa',
    dontHaveAccount: "Nemáte ešte účet?",
    creatingAccount: 'Vytváranie účtu...',
    registrationNote: 'Poznámka:',
    registrationNotePoints: {
      erpLinking: 'Ak už máte existujúci firemný účet, váš e-mail bude automaticky prepojený',
      companyEmail: 'Na registráciu použite firemnú e-mailovú adresu',
      contactSupport: 'Ak potrebujete pomoc s registráciou, kontaktujte podporu'
    },
    b2bUsers: 'Používatelia firemného účtu:',
    registeredEmail: 'Registrovaná e-mailová adresa',
    registeredPassword: 'Heslo nastavené pri registrácii',
    b2bCustomerRequired: 'Táto e-mailová adresa nie je registrovaná ako firemný zákazník. Kontaktujte prosím obchodné oddelenie pre nadviazanie spolupráce.',
    b2bVerificationError: 'Nepodarilo sa overiť status firemného zákazníka. Kontaktujte prosím podporu.',
    // Password Reset
    passwordReset: 'Obnovenie hesla',
    passwordResetDescription: 'Zadajte svoju e-mailovú adresu pre získanie dočasného hesla',
    getTemporaryPassword: 'Získať dočasné heslo',
    processing: 'Spracováva sa...',
    passwordResetComplete: 'Obnovenie hesla dokončené',
    temporaryPasswordGenerated: 'Dočasné heslo bolo vygenerované',
    temporaryPassword: 'Dočasné heslo',
    backToLogin: 'Späť na prihlásenie',
    securityNotice: 'Bezpečnostné upozornenie:',
    securityNotePoints: {
      keepSecret: 'Dočasné heslo nezdieľajte s inými osobami',
      changeAfterLogin: 'Po prihlásení si nezabudnite zmeniť heslo',
      expires24Hours: 'Dočasné heslo vyprší po 24 hodinách'
    },
    resetNote: 'Poznámka:',
    resetNotePoints: {
      registeredEmail: 'Zadajte svoju registrovanú e-mailovú adresu',
      passwordDisplayed: 'Dočasné heslo sa zobrazí na obrazovke',
      changeRequired: 'Po prihlásení je vyžadovaná zmena hesla'
    },
    copied: 'Skopírované',
    copySuccessMessage: 'Dočasné heslo bolo skopírované do schránky.',
    forgotPassword: 'Zabudli ste heslo?',
    // Password Reset Email Request
    sendResetLink: 'Odoslať odkaz na obnovenie',
    sendingEmail: 'Odosielanie e-mailu...',
    emailSent: 'E-mail odoslaný',
    emailSentMessage: 'Ak táto e-mailová adresa existuje v našom systéme, čoskoro dostanete odkaz na obnovenie hesla.',
    emailNotSent: 'E-mail nebol odoslaný',
    emailSentInfo: 'Skontrolujte doručenú poštu a priečinok spam',
    checkEmail: 'Skontrolujte e-mail',
    emailInstructions: 'Inštrukcie na obnovenie hesla boli odoslané',
    nextSteps: 'Ďalšie kroky:',
    nextStepsList: {
      checkInbox: 'Skontrolujte doručenú poštu a priečinok spam',
      clickLink: 'Kliknite na odkaz na obnovenie v e-maile',
      linkExpires: 'Odkaz vyprší o 24 hodín',
      contactSupport: 'Ak e-mail nedostanete, kontaktujte podporu',
      rateLimitInfo: 'Obmedzené na 3 žiadosti za hodinu'
    },
    // Password Reset Completion
    resetLinkSent: 'Odkaz na obnovenie odoslaný',
    resetSuccess: 'Heslo úspešne obnovené',
    passwordUpdated: 'Heslo aktualizované',
    passwordUpdateMessage: 'Vaše heslo bolo úspešne aktualizované. Teraz sa môžete prihlásiť s novým heslom.',
    loginWithNewPassword: 'Prihlásiť sa novým heslom',
    // Reset Token Page
    resetToken: 'Obnoviť heslo',
    invalidToken: 'Neplatný token na obnovenie',
    expiredToken: 'Token na obnovenie vypršal',
    tokenValid: 'Token na obnovenie je platný',
    newPassword: 'Nové heslo',
    confirmNewPassword: 'Potvrdenie nového hesla',
    updatePassword: 'Aktualizovať heslo',
    updatingPassword: 'Aktualizácia hesla...',
    passwordMismatch: 'Heslá sa nezhodujú',
    resetInstructions: 'Zadajte svoje nové heslo pre dokončenie obnovy',
  },
  accountInfo: {
    title: 'Informácie o účte',
    loading: 'Načítavanie informácií o účte...',
    error: 'Chyba',
    errorMessage: 'Nepodarilo sa načítať informácie o účte',
    back: 'Späť',
    basicInfo: 'Základné informácie',
    name: 'Meno',
    email: 'E-mailová adresa',
    contactId: 'Knitido Zákaznícke ID',
    contactNumber: 'Kontaktné číslo',
    noInfo: 'Žiadne informácie',
    companyInfo: 'Informácie o spoločnosti',
    company: 'Názov spoločnosti',
    position: 'Pozícia',
    vatId: 'IČ DPH',
    billingAddress: 'Fakturačná adresa',
    deliveryAddress: 'Dodacia adresa',
    addressInfo: 'Informácie o adrese',
    billingDescription: 'Adresa pre faktúry a zmluvné dokumenty',
    deliveryDescription: 'Štandardná dodacia adresa pre zásielky produktov',
    sameAsBilling: '※ Rovnaká ako fakturačná adresa',
    sameAsDelivery: '※ Rovnaká ako dodacia adresa',
    companyName: 'Názov spoločnosti',
    contactPerson: 'Kontaktná osoba',
    address: 'Adresa',
    phoneNumber: 'Telefónne číslo',
    billingUsage: 'Používa sa ako cieľ pre faktúry, zmluvy a iné dôležité dokumenty',
    deliveryUsage: 'Používa sa ako štandardná dodacia adresa pre objednané produkty',
    alsoUsedForDelivery: 'Používa sa aj ako dodacia adresa',
    accountType: 'Typ účtu',
    addressId: 'ID Adresy',
    // Address editing functionality
    edit: 'Upraviť',
    editDeliveryAddress: 'Upraviť dodaciu adresu',
    editDeliveryDescription: 'Aktualizujte informácie o vašej dodacej adrese',
    newDeliveryAddress: 'Pridať novú dodaciu adresu',
    newDeliveryDescription: 'Zadajte údaje pre vašu novú dodaciu adresu',
    noDeliveryAddress: 'Nie je nastavená žiadna dodacia adresa',
    success: 'Úspech',
    addressUpdated: 'Dodacia adresa úspešne aktualizovaná',
    updateError: 'Nepodarilo sa aktualizovať dodaciu adresu',
    requiredFields: 'Prosím vyplňte všetky povinné polia',
    firstName: 'Meno',
    lastName: 'Priezvisko',
    streetAddress: 'Ulica a číslo',
    streetAddress2: 'Adresa 2',
    city: 'Mesto',
    country: 'Krajina',
    selectCountry: 'Vyberte krajinu...',
    searchCountry: 'Hľadať krajinu...',
    noCountryFound: 'Krajina nenájdená.',
    postalCode: 'PSČ',
    companyNamePlaceholder: 'Zadajte názov spoločnosti',
    firstNamePlaceholder: 'Meno',
    lastNamePlaceholder: 'Priezvisko',
    streetAddressPlaceholder: 'Zadajte ulicu a číslo',
    streetAddress2Placeholder: 'Byt, poschodie, atď.',
    cityPlaceholder: 'Zadajte mesto',
    postalCodePlaceholder: 'Zadajte PSČ',
    billingNotEditable: 'Fakturačnú adresu nie je možné upravovať.',
    billingContactSupport: 'Pre zmeny kontaktujte podporu.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} dodacích adries',
    noDeliveryAddresses: 'Žiadne registrované dodacie adresy',
    defaultAddress: 'Predvolená',
    selectDeliveryAddress: 'Vyberte dodaciu adresu',
    addNewAddress: 'Pridať novú adresu',
    editAddress: 'Upraviť adresu',
    deleteAddress: 'Vymazať adresu',
    confirmDelete: 'Potvrdiť vymazanie',
    confirmDeleteMessage: 'Naozaj chcete vymazať túto adresu? Túto akciu nie je možné vrátiť späť.',
    addressAddedSuccess: 'Dodacia adresa pridaná',
    addressDeletedSuccess: 'Dodacia adresa vymazaná',
    deleteError: 'Nepodarilo sa vymazať dodaciu adresu',
    saving: 'Ukladá sa...',
    cancel: 'Zrušiť',
    saveChanges: 'Uložiť zmeny',
    selectedDeliveryAddress: 'Vybraná dodacia adresa',
  },
  dashboard: {
    title: 'Obchodný partner',
    subtitle: 'Objednávkový systém produktov',
    welcome: 'Vitajte,',
    welcomeMessage: 'Vitajte v objednávkovom systéme pre obchodných partnerov. Tu si môžete objednať produkty.',
    productCatalog: 'Katalóg produktov',
    productCatalogDesc: 'Prezerať a objednať dostupné produkty',
    viewProducts: 'Zobraziť produkty',
    orderHistory: 'História objednávok',
    orderHistoryDesc: 'Zobraziť minulé objednávky (pripravujeme)',
    accountSettings: 'Nastavenia účtu',
    accountSettingsDesc: 'Správa informácií o účte (pripravujeme)',
    comingSoon: 'Pripravujeme',
    infoTitle: 'O používaní',
    orderingInfo: 'Objednávanie produktov',
    orderingDesc: 'Vyberte produkty z katalógu a určite veľkosť a farbu. K dispozícii sú informácie o zásobách v reálnom čase.',
    supportInfo: 'Podpora',
    supportDesc: 'Ak máte akékoľvek otázky, kontaktujte nás.',
    viewOrderHistory: 'Zobraziť históriu objednávok',
    viewOrders: 'Zobraziť objednávky',
    accountInfo: 'Informácie o účte',
    accountInfoDesc: 'Zobraziť detaily vášho účtu',
    viewDetails: 'Zobraziť detaily',
    supportEmail: 'b2b-partner @knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Pondelok-Piatok 9:00 - 15:00 CET',
    bulkImportDesc: 'Import objednávok zo súborov Excel/CSV',
    importOrders: 'Importovať objednávky',
  },
  products: {
    title: 'Zoznam produktov',
    subtitle: 'Obchodný partner',
    searchPlaceholder: 'Hľadať podľa názvu produktu alebo SKU...',
    productId: 'ID Produktu',
    addToCart: 'Pridať do košíka',
    selectVariation: 'Vybrať variant',
    price: 'Cena',
    priceNetNotice: 'Všetky ceny sú bez DPH',
    stock: 'Sklad',
    color: 'Farba',
    newProducts: 'Nové produkty',
    newProductBadge: 'NOVÉ',
    size: 'Veľkosť',
    quantity: 'Množstvo',
    total: 'Celkom',
    cart: 'Košík',
    checkout: 'Pokladňa',
    csvMode: 'CSV Rýchly režim',
    csvInfo: 'Dáta produktov získané z CSV',
    csvUploadDate: 'Dátum nahrania CSV:',
    stockNote: '※ Informácie o sklade sa načítajú pri výbere variantov produktu',
    noProducts: 'Nenašli sa žiadne produkty',
    noProductsDesc: 'Zmeňte kritériá vyhľadávania alebo nahrajte CSV súbor pre rýchlejší výkon.',
    retry: 'Skúsiť znova',
    pagination: 'položiek',
    variations: 'variantov',
    stockFetchError: 'Chyba pri získavaní zásob',
    stockFetchFailed: 'Nepodarilo sa získať zásoby',
    stockFetchFailedDesc: 'Nepodarilo sa načítať informácie o sklade. Zobrazia sa zásoby z CSV.',
    stockFetched: 'Informácie o sklade načítané',
    totalStock: 'Celkové zásoby',
    noStockAll: 'Všetky varianty majú nulové zásoby',
    noStockData: 'Žiadne údaje o zásobách',
    stockFetchErrorDesc: 'Nastala chyba pri načítavaní informácií o sklade',
    selectionError: 'Chyba výberu',
    enterQuantity: 'Prosím zadajte množstvo',
    addedToCart: 'Pridané do košíka',
    typesAdded: ' typov produktov pridaných',
    addToCartError: 'Chyba pridania do košíka',
    addToCartErrorDesc: 'Skúste to prosím znova',
    loadingStock: 'Načítavanie informácií o sklade',
    csvDataInfo: 'Zobrazujú sa informácie z CSV (nie aktuálny stav skladu)',
    invalidDataFormat: 'Formát údajov o produkte je neplatný',
    loadFailed: 'Nepodarilo sa načítať údaje o produkte',
    csvUploadComplete: 'CSV nahrané',
    csvLoadedDesc: ' údajov o produktoch načítaných. Informácie o sklade sa načítajú pri výbere produktov.',
    searchTitle: 'Vyhľadávanie produktov',
    loadingProducts: 'Načítavanie údajov o produktoch',
    noProductsCsv: 'V CSV dátach sa nenašli žiadne produkty. Prosím zmeňte kritériá vyhľadávania.',
    paginationDisplay: ' zobrazených',
    previous: 'Predchádzajúce',
    next: 'Ďalšie',
    selectionSummary: 'Súhrn výberu',
    selectedQuantity: 'Vybrané množstvo',
    items: ' položiek',
    viewDetails: 'Zobraziť detaily',
    productImage: 'Obrázok produktu',
    correspondingVariations: 'Zodpovedajúce varianty',
    clickToEnlarge: 'Kliknite pre zväčšenie',
    productIdLabel: 'ID Produktu',
    colorLabel: 'Farba',
    filterByCategory: 'Filtrovať podľa kategórie',
    allProducts: 'Všetky produkty',
    applyFilters: 'Použiť filtre',
    clearFilters: 'Vymazať filtre',
    filters: 'Filtre',
    clearAll: 'Vymazať všetko',
  },
  categories: {
    category_21: 'Prstové ponožky',
    category_23: 'Nezaradené',
    category_24: 'Oblečenie',
    category_29: 'B2B Produkty',
  },
  productDetail: {
    title: 'Detaily produktu',
    backToProducts: 'Späť na produkty',
    productNotFound: 'Produkt nenájdený',
    productNotFoundDesc: 'Zadaný produkt neexistuje alebo bol vymazaný.',
    loading: 'Načítavanie produktu...',
    imageLoadError: 'Nepodarilo sa načítať obrázky',
    noImages: 'Žiadne obrázky k dispozícii',
    productDescription: 'Popis produktu',
    colors: 'Farby',
    sizes: 'Veľkosti',
    colorCount: 'farieb',
    sizeCount: 'veľkostí',
    variationCount: 'variantov',
    selectVariation: 'Vybrať varianty',
    descriptionLanguageNote: '※ Popisy produktov sú k dispozícii iba v angličtine alebo nemčine',
  },
  colors: {
    schwarz: 'Čierna',
    weiß: 'Biela',
    grau: 'Sivá',
    rot: 'Červená',
    blau: 'Modrá',
    grün: 'Zelená',
    gelb: 'Žltá',
    rosa: 'Ružová',
    lila: 'Fialová',
    braun: 'Hnedá',
    orange: 'Oranžová',
    beige: 'Béžová',
    navy: 'Námornícka modrá',
    dunkelblau: 'Tmavomodrá',
    hellblau: 'Svetlomodrá',
    dunkelgrau: 'Tmavosivá',
    hellgrau: 'Svetlosivá',
    bordeaux: 'Bordeaux',
    türkis: 'Tyrkysová',
    khaki: 'Khaki',
    mint: 'Mätová',
    violett: 'Fialová',
    anthrazit: 'Antracit',
    blaugrau: 'Modrosivá',
    burgunderrot: 'Burgundská červená',
    elfenbein: 'Slonovina',
    karminrot: 'Karmínová',
    neongrün: 'Neónová zelená',
    gelbgrün: 'Žltozelená',
    pistazie: 'Pistáciová',
    // English color names
    blue: 'Modrá',
    ivory: 'Slonovina',
    green: 'Zelená',
    gold: 'Zlatá',
    red: 'Červená',
  },
  checkout: {
    title: 'Pokladňa',
    cartReview: 'Kontrola objednávky',
    orderSummary: 'Súhrn objednávky',
    shippingInfo: 'Informácie o doprave',
    billingInfo: 'Fakturačné údaje',
    orderNotes: 'Poznámky k objednávke',
    orderNotesPlaceholder: 'Špeciálne požiadavky alebo poznámky...',
    contactPerson: 'Kontaktná osoba',
    phoneNumber: 'Telefónne číslo',
    email: 'E-mailová adresa',
    company: 'Spoločnosť',
    address: 'Adresa',
    city: 'Mesto',
    postalCode: 'PSČ',
    country: 'Krajina',
    deliveryDate: 'Dátum doručenia',
    urgentDelivery: 'Expresné doručenie (3-5 pracovných dní)',
    standardDelivery: 'Štandardné doručenie (7-10 pracovných dní)',
    placeOrder: 'Odoslať objednávku',
    backToCart: 'Späť na výber produktov',
    requiredField: 'Povinné pole',
    orderTotal: 'Objednávka spolu',
    subtotal: 'Medzisúčet',
    priceNetNotice: 'Všetky ceny sú bez DPH',
    stockReservationNotice: 'Rezervácia tovaru prebehne po potvrdení objednávky.',
    stockCheckError: 'Chyba kontroly zásob',
    stockCheckErrorDesc: 'Pri kontrole zásob nastala chyba. Skúste to prosím znova.',
    shipping: 'Doprava',
    shippingCost: 'Cena dopravy',
    tax: 'DPH',
    orderSuccess: 'Objednávka úspešná',
    orderSuccessMessage: 'Vaša objednávka bola úspešne odoslaná. Číslo objednávky: {orderNumber}',
    orderNumber: 'Číslo objednávky',
    thankYou: 'Ďakujeme za vašu objednávku!',
    orderConfirmation: 'Vaša objednávka bola úspešne odoslaná.',
    orderProcessing: 'Po kontrole naším tímom vám zašleme potvrdenie objednávky e-mailom.',
    orderProcessingMessage: 'Vaša objednávka bola úspešne odoslaná. Po kontrole naším tímom vám zašleme potvrdenie objednávky e-mailom.',
    continueShopping: 'Pokračovať v nákupe',
    emptyCart: 'Váš košík je prázdny',
    emptyCartMessage: 'Pre pokračovanie pridajte produkty do košíka',
    stockWarning: 'Upozornenie na zásoby',
    stockWarningDesc: 'Niektoré položky nemajú dostatočné zásoby. Prosím upravte množstvá.',
    stockError: 'Chyba zásob',
    stockErrorDesc: 'Niektoré položky majú nedostatočné zásoby. Prosím upravte množstvá.',
    refreshStock: 'Obnoviť zásoby',
    stockUpdated: 'Zásoby aktualizované',
    stockUpdatedDesc: 'Zásoby boli aktualizované - {changed} položiek zmenených',
    stockCheckDesc: 'Zobrazujú sa výsledky porovnania so skladom',
    stockOk: 'Sklad OK',
    stockShortage: 'Nedostatok na sklade',
    requestedQty: 'Požadované množstvo',
    currentStock: 'Aktuálne na sklade',
    stockShortageMsg: 'Nedostatočné zásoby. Prosím upravte množstvo.',
    stockIssueWarning: 'Objednávku nie je možné potvrdiť kvôli problémom so zásobami.',
    stockDataMissing: 'Údaje o zásobách sa načítavajú. Prosím čakajte.',
    outOfStock: 'Vypredané.',
    maxAvailable: 'Maximum',
    autoRestored: 'Košík obnovený',
    autoRestoredDesc: 'Položky z vašej poslednej relácie boli obnovené',
    maxQuantityReached: 'Dosiahnuté maximálne množstvo na sklade.',
    // ERP Contact Search
    contactSearch: 'Vyhľadávanie kontaktu zákazníka',
    contactSearchDesc: 'Zadajte e-mailovú adresu objednávateľa pre získanie kontaktných informácií',
    emailAddress: 'E-mailová adresa',
    searchButton: 'Hľadať',
    searching: 'Hľadanie',
    contactFound: 'Kontakt nájdený',
    contactNotFound: 'Kontakt nenájdený',
    contactId: 'Knitido Zákaznícke ID',
    companyName: 'Spoločnosť',
    contactPersonLabel: 'Kontaktná osoba',
    addressesFound: 'Nájdené adresy',
    addressType: 'Typ',
    addressBilling: 'Fakturačná adresa',
    addressDelivery: 'Dodacia adresa',
    vatSourceCompany: 'Info o firme',
    vatSourceBilling: 'Fakturácia',
    vatSourceDelivery: 'Dodanie',
    addressOther: 'Iné',
    addressDetails: 'Adresa',
    loadingAddresses: 'Načítavanie informácií o adrese...',
    addressRetrieved: 'Informácie o adrese načítané',
    addressNotFound: 'Informácie o adrese nenájdené',
    addressNotFoundDesc: 'Žiadne registrované informácie o adrese. Prosím zadajte manuálne.',
    addressError: 'Chyba pri získavaní adresy',
    addressErrorDesc: 'Nepodarilo sa získať informácie o adrese.',
    contactNotConfirmed: 'Kontakt zákazníka nepotvrdený',
    contactNotConfirmedDesc: 'Prosím zadajte e-mailovú adresu a vyhľadajte kontakt.',
    searchContact: 'Hľadať kontakt',
    inputError: 'Chyba vstupu',
    inputErrorDesc: 'Informácie o doprave sú neúplné. Prosím skontrolujte ich.',
    processing: 'Spracováva sa...',
    erpContactSearch: 'Vyhľadávanie kontaktu zákazníka',
    contactSearchError: 'E-mailová adresa nezodpovedá žiadnemu registrovanému kontaktu.',
    // Product Images Toggle
    showProductImages: 'Zobraziť obrázky produktov',
    showProductImagesDesc: 'Zobraziť obrázky produktov pre lepší prehľad (môže predĺžiť čas načítania)',
    // System Registration Info
    systemRegistrationInfo: 'Vaše zákaznícke informácie',
    editShippingAddress: 'Upraviť dodaciu adresu',
    systemRegistrationInfoDesc: 'Vaše registrované firemné údaje. Kontaktujte prosím svojho zástupcu, ak potrebujete aktualizovať fakturačné údaje.',
    // Order Summary
    regularPrice: 'Bežná veľkoobchodná cena',
    offeredPrice: 'Ponúknutá cena',
    discount: 'Zľava',
    b2bCustomer: 'B2B Zákazník',
    pattern: 'Vzor',
    specialPriceApplied: 'Uplatnená špeciálna cena',
    customerClassification: 'Klasifikácia zákazníka',
    paymentCondition: 'Platobné podmienky',
    invoice: 'Faktúra (splatnosť 30 dní)',
    prepayment: 'Platba vopred',
    paymentMethod: 'Spôsob platby',
    invoicePayment: 'Platba na faktúru',
    estimatedSubtotal: 'Odhadovaný medzisúčet',
    estimatedTotal: 'Odhadovaná celková suma',
    orderSummaryDisclaimer: 'Ceny uvedené tu sú odhady. Po prijatí vašej objednávky ju skontrolujeme a zašleme vám záväzné potvrdenie objednávky s konečnými cenami, nákladmi na dopravu a daňami e-mailom.',
    searchError: 'Chyba vyhľadávania',
    searchErrorDesc: 'Počas vyhľadávania kontaktu nastala chyba.',
    confirmDeleteItem: 'Odstrániť položku',
    itemDeleted: 'Položka odstránená',
    confirmDeleteItemDesc: 'Naozaj chcete odstrániť túto položku z košíka?',
    deleteConfirm: 'Odstrániť',
    contactNotes: 'Poznámky ku kontaktu',
    contactNotesDesc: 'Máte nejaké otázky alebo špeciálne požiadavky? Dajte nám vedieť (voliteľné)',
    contactNotesLabel: 'Správa',
    contactNotesPlaceholder: 'napr.: Otázky k produktom, špeciálne požiadavky, atď.',
    characters: 'znakov',
    contactIdLabel: 'Knitido Zákaznícke ID',
    companyLabel: 'Spoločnosť',
    personLabel: 'Kontaktná osoba',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Typ',
    destinationLabel: 'Cieľ',
    // Shipping Form
    shippingTitle: 'Informácie o doprave',
    shippingDesc: 'Zadajte dodaciu adresu pre produkty',
    companyRequired: 'Spoločnosť *',
    contactPersonRequired: 'Kontaktná osoba *',
    emailRequired: 'E-mailová adresa *',
    phoneRequired: 'Telefónne číslo *',
    addressRequired: 'Adresa 1 *',
    address2: 'Adresa 2 (Budova/Miestnosť)',
    postalCodeRequired: 'PSČ *',
    cityRequired: 'Mesto *',
    countryRequired: 'Krajina *',
    selectCountry: 'Vyberte krajinu',
    shippingMethodRequired: 'Spôsob dopravy *',
    selectShippingMethod: 'Vyberte spôsob dopravy',
    urgentDeliveryOption: 'Expresné doručenie (dodatočné poplatky)',
    deliveryNotes: 'Poznámky k doručeniu',
    deliveryNotesPlaceholder: 'Zadajte preferencie času doručenia alebo iné požiadavky',
    standardShipping: 'Štandardná doprava (3-5 pracovných dní)',
    expressShipping: 'Expresná doprava (1-2 pracovné dni)',
    overnightShipping: 'Doručenie do druhého dňa',
    germany: 'Nemecko',
    austria: 'Rakúsko',
    switzerland: 'Švajčiarsko',
    japan: 'Japonsko',
    shippingAddressLabel: 'Dodacia adresa',
    changeDeliveryAddress: 'Zmeniť dodaciu adresu',
    selectDeliveryAddress: 'Vybrať dodaciu adresu',
    // Shipping Cost Details
    freeShipping: 'Doprava zdarma',
    shippingError: 'Chyba',
    shippingZone: 'Dopravná zóna',
    remainingForFreeShipping: 'ešte {amount} pre dopravu zdarma',
    moreForFreeShipping: 'viac pre dopravu zdarma',
    freeShippingProgress: 'Doprava zdarma pri',
    andAboveFreeShipping: 'a viac pre dopravu zdarma',
    freeShippingAchieved: 'Uplatnená doprava zdarma',
    threshold: 'a viac',
    nextShippingTier: 'Ďalšia úroveň dopravy',
    moreForDiscount: 'viac pre',
    shippingSavings: 'úspora na doprave',
    orderAmountThreshold: 'a viac pre',
    specialRegionNotice: 'Uplatnený špeciálny región dopravy',
    defaultShippingApplied: 'Uplatnené štandardné ceny dopravy',
    requestedQuantity: 'Požadované množstvo',
    availableQuantity: 'Dostupné množstvo',
    orderSubmitError: 'Chyba odoslania objednávky',
    orderSubmitErrorDesc: 'Objednávku sa nepodarilo odoslať',
    upload: {
      title: 'Import objednávky z Excel/CSV',
      description: 'Nahrajte súbor Excel alebo CSV s údajmi vašej objednávky',
      dragDropOrClick: 'Potiahnite a pustite súbor sem alebo kliknite pre výber',
      dropHere: 'Pustite súbor sem',
      supportedFormats: 'Podporované formáty: Excel (.xlsx, .xls) a CSV (.csv)',
      maxSize: 'Maximálna veľkosť súboru: {size} MB',
      processFile: 'Spracovať súbor',
      processing: 'Spracováva sa súbor...',
      ready: 'Súbor pripravený na náhľad',
      readyDescription: 'Váš súbor bol úspešne spracovaný a je pripravený na kontrolu.',
      preview: 'Zobraziť náhľad',
      errors: {
        fileTooLarge: 'Súbor je príliš veľký. Maximálna veľkosť: {size} MB',
        invalidFileType: 'Neplatný typ súboru. Prosím nahrajte súbor Excel alebo CSV',
        uploadFailed: 'Chyba pri nahrávaní súboru',
      },
    },
    // Loading messages
    loadingPage: 'Načítava sa stránka...',
    loadingStock: 'Kontrola skladových zásob...',
    loadingAccount: 'Načítavanie informácií o účte...',
    loadingError: 'Nastala chyba...',
    loadingData: 'Načítavanie dát',
    // Toast messages
    addressRetrievedTitle: 'Informácie o adrese načítané',
    addressSetAsDelivery: ' adresa nastavená ako cieľ doručenia.',
    contactFoundDesc: ' bol rozpoznaný.'
  },
  orderHistory: {
    title: 'História objednávok',
    searchPlaceholder: 'Hľadať podľa čísla objednávky alebo SKU...',
    noOrders: 'Nenašli sa žiadne objednávky',
    noOrdersFound: 'Nenašli sa žiadne zodpovedajúce objednávky',
    startShopping: 'Zobraziť produkty',
    orderItems: 'Položky objednávky',
    viewDetails: 'Detaily',
    reorder: 'Objednať znova',
    orderDate: 'Dátum objednávky',
    orderStatus: 'Stav',
    orderTotal: 'Objednávka spolu',
    // Status translations
    statusPending: 'Čaká na platbu',
    statusProcessing: 'Spracováva sa',
    statusConfirmed: 'Potvrdená',
    statusShipped: 'Odoslaná',
    statusDelivered: 'Doručená',
    statusCancelled: 'Zrušená',
    statusReturned: 'Vrátená',
    statusRefunded: 'Vrátené peniaze',
    statusWarranty: 'Reklamácia',
    statusExchanged: 'Vymenená',
    statusRepair: 'Oprava',
    statusUnknown: 'Neznámy',
    statusIncomplete: 'Neúplná',
    statusWaitingPayment: 'Čaká na platbu',
    statusInPreparation: 'Pripravuje sa',
    statusClearedShipping: 'Pripravené na odoslanie',
    statusBeingShipped: 'Odosiela sa',
    statusOutgoingBooked: 'Výstup zaevidovaný',
    statusReturn: 'Vrátenie',
    // Additional UI elements
    itemCount: 'položiek',
    itemCountSingular: 'položka',
    refreshButton: 'Obnoviť',
    errorFetchingOrders: 'Nepodarilo sa načítať históriu objednávok',
    // Payment status features
    paymentStatus: 'Stav platby',
    markAsPaid: 'Označiť ako zaplatené',
    unmarkAsPaid: 'Zrušiť označenie zaplatené',
    paidOn: 'Zaplatené dňa',
    paymentMarked: 'Zaplatené',
    notPaid: 'Nezaplatené',
    paymentMarkedSuccess: 'Úspešne označené ako zaplatené',
    paymentUnmarkedSuccess: 'Označenie platby odstránené',
    paymentUpdateError: 'Nepodarilo sa aktualizovať stav platby',
    // Payment date dialog
    paymentDateTitle: 'Zadať informácie o platbe',
    paymentDateDescription: 'Zadajte informácie o platbe pre objednávku {orderNumber}',
    paymentDateLabel: 'Dátum platby',
    selectDate: 'Vybrať dátum',
    paymentDateHelp: 'Vyberte dátum, kedy bol vykonaný bankový prevod',
    paymentMethodLabel: 'Spôsob platby',
    bankTransfer: 'Bankový prevod',
    invoice: 'Faktúra',
    otherPayment: 'Iné',
    paymentReferenceLabel: 'Názov prevodu / Referenčné číslo',
    paymentReferencePlaceholder: 'napr., Ján Novák, Prevod #12345',
    paymentReferenceHelp: 'Zadajte informácie, ktoré pomôžu pri párovaní s bankovými výpismi',
    notesLabel: 'Poznámky',
    notesPlaceholder: 'Zadajte akékoľvek ďalšie informácie o platbe',
    // Filter options
    filterByPaymentStatus: 'Filtrovať podľa stavu platby',
    allOrders: 'Všetky objednávky',
    paidOrders: 'Zaplatené',
    unpaidOrders: 'Nezaplatené',
    // Sorting options
    sortBy: 'Zoradiť podľa',
    sortByDate: 'Dátum objednávky',
    sortByPaymentDate: 'Dátum platby',
    sortByAmount: 'Suma',
    sortByStatus: 'Stav',
  },
  orderDetails: {
    title: 'Detaily objednávky',
    notFound: 'Objednávka nenájdená',
    backToHistory: 'Späť na históriu objednávok',
    orderDate: 'Dátum objednávky',
    orderItems: 'Položky objednávky',
    deliveryStatus: 'Stav doručenia',
    estimatedDelivery: 'Odhadované doručenie',
    deliveredOn: 'Doručené dňa',
    downloadInvoice: 'Stiahnuť faktúru',
    statusDelivered: 'Doručená',
    statusShipped: 'Odoslaná',
    statusConfirmed: 'Potvrdená',
    statusCancelled: 'Zrušená',
    errorFetchingDetails: 'Nepodarilo sa načítať detaily objednávky',
  },
  company: {
    name: 'Obchodný partner',
    tagline: 'Systém obchodných partnerov',
    copyright: '© 2025 Systém obchodných partnerov. Všetky práva vyhradené.',
  },
  footer: {
    phone: 'Telefón',
    email: 'E-mail',
    countries: {
      DE: 'Nemecko',
      AT: 'Rakúsko',
      CH: 'Švajčiarsko',
      FR: 'Francúzsko',
      IT: 'Taliansko',
      ES: 'Španielsko',
      NL: 'Holandsko',
      BE: 'Belgicko',
      PL: 'Poľsko',
      SE: 'Švédsko',
      NO: 'Nórsko',
      FI: 'Fínsko',
      DK: 'Dánsko',
      LT: 'Litva',
      LV: 'Lotyšsko',
      EE: 'Estónsko',
    },
  },
  cart: {
    newCart: 'Nový košík',
    currentCart: 'Aktuálny košík',
    modified: 'zmenené',
    lastSaved: 'Naposledy uložené',
    unsavedChanges: 'neuložené zmeny',
    saveCart: 'Uložiť košík',
    loadCart: 'Načítať košík',
    deleteCart: 'Vymazať košík',
    startNewCart: 'Začať nový košík',
    savedCarts: 'Uložené košíky',
    cartSaved: 'Košík uložený',
    cartDeleted: 'Košík vymazaný',
    confirmDeleteCart: 'Vymazať košík?\n\nTúto akciu nie je možné vrátiť späť.',
    confirmSwitchCart: 'Aktuálny košík má neuložené zmeny.\n\nNačítanie iného košíka spôsobí stratu aktuálnych zmien.\n\nPokračovať?',
    confirmSwitchCartTitle: 'Zmeniť košík',
    confirmNewCart: 'Aktuálny košík má neuložené zmeny.\n\nZačatie nového košíka spôsobí stratu aktuálnych zmien.\n\nPokračovať?',
    confirmNewCartTitle: 'Začať nový košík',
    confirmClearCart: 'Vyprázdniť košík?\n\n{count} položiek bude odstránených.\n\nTúto akciu nie je možné vrátiť späť.',
    confirmClearCartTitle: 'Vyprázdniť košík',
    autoSaved: 'Automaticky uložené',
    itemsWillBeRemoved: 'položiek bude odstránených',
    changesWillBeLost: 'zmeny budú stratené',
    continueQuestion: 'Pokračovať?',
    cartStatus: 'Stav košíka',
    cartName: 'Názov košíka',
    cartNamePlaceholder: 'napr.: Objednávka na konci mesiaca',
    cartNameRequired: 'Prosím zadajte názov košíka',
    saveCartDescription: 'Pomenujte aktuálny košík a uložte ho. Neskôr ho môžete načítať.',
    cancelCart: 'Zrušiť košík',
    proceedToCheckout: 'Prejsť k pokladni',
    emptyCart: 'Košík je prázdny',
    erpDown: 'Systém objednávok je mimo prevádzky. Skúste to prosím neskôr.',
    erpDegraded: 'Systém je momentálne nestabilný. Objednávky môžu zlyhať.',
    erpDownSaveHint: 'Uložte košík a objednajte po obnovení systému.',
    erpSaveCart: 'Uložiť košík',
  },
  nav: {
    dashboard: 'Prehľad',
    products: 'Produkty',
    orderHistory: 'História objednávok',
    account: 'Info o účte',
    bulkImport: 'Hromadný import',
  },
  settings: {
    selectLanguage: 'Vyberte jazyk',
    languagePreferenceSaved: 'Vaša preferencia bude uložená vo vašom účte pre budúce návštevy.',
  },
  reorder: {
    allItemsAdded: '{count} položiek pridaných do košíka',
    partialSuccess: '{added} položiek pridaných. {failed} položiek sa nepodarilo pridať',
    allItemsFailed: 'Nepodarilo sa pridať položky do košíka',
    error: 'Počas opakovanej objednávky nastala chyba',
    itemDiscontinued: '{name} ({color}/{size}) sa už nepredáva',
    itemOutOfStock: '{name} ({color}/{size}) nie je na sklade',
    partialStock: '{name} ({color}/{size}) iba {available} k dispozícii',
    confirmReorder: 'Potvrdiť opakovanú objednávku',
    confirmReorderMessage: 'Pridať položky z tejto objednávky do košíka?',
    addingToCart: 'Pridávanie do košíka...',
    checkingStock: 'Kontrola zásob...',
    checkoutTitle: 'Položky pridané do košíka',
    checkoutDescription: '{count} položiek bolo pridaných do vášho košíka. Chcete prejsť k pokladni?',
  },
  bulkImport: {
    instructions: 'Ako importovať objednávky',
    step1: 'Stiahnite si súbor šablóny objednávky',
    step2: 'Vyplňte údaje o objednávke s SKU a množstvom',
    step3: 'Uložte ako súbor Excel (.xlsx) alebo CSV',
    step4: 'Nahrajte súbor pomocou formulára nižšie',
    step5: 'Skontrolujte a potvrďte vašu objednávku',
    downloadTemplate: 'Stiahnuť šablónu',
    downloadExcelTemplate: 'Stiahnuť Excel šablónu',
    downloadCsvTemplate: 'Stiahnuť CSV šablónu',
    formatGuide: 'Sprievodca formátom súboru',
    requiredColumns: 'Povinné stĺpce',
    skuDescription: 'Kód SKU produktu',
    quantityDescription: 'Objednávané množstvo (kladné celé číslo)',
    optionalColumns: 'Voliteľné stĺpce',
    notesDescription: 'Interné poznámky (napr. číslo objednávky, referencia) - len pre vašu evidenciu',
    formatNote: 'Prvý riadok by mal obsahovať hlavičky stĺpcov. Dáta začínajú od druhého riadku.',
    parseSuccess: 'Úspešne spracovaných {count} položiek zo súboru',
    parseError: 'Chyba spracovania',
    validationError: 'Chyby validácie',
    validationErrorGuidance: 'Prosím kliknite na tlačidlo "{showPreviewButton}" pre zobrazenie detailov.',
    warnings: 'Upozornenia',
    itemsParsed: 'Úspešne spracovaných {count} položiek:',
    andMore: '...a {count} ďalších položiek',
    validationSummary: 'Súhrn validácie',
    duplicateSKUs: 'Nájdené duplicitné SKU',
    skuFormat: 'SKU môže obsahovať iba písmená, čísla a pomlčky',
    quantityRange: 'Množstvo musí byť medzi 1 a 9999',
    maxRows: 'Povolených maximálne 1000 riadkov',
    rowsSkipped: '{count} riadkov bolo preskočených kvôli chybám',
    previewTitle: 'Náhľad objednávky',
    previewDescription: 'Skontrolujte a upravte údaje objednávky pred pokračovaním',
    proceedToCart: 'Pridať do košíka',
    // File parsing messages
    fileEmpty: 'Súbor je prázdny alebo neobsahuje žiadne dáta',
    fileTooManyRows: 'Súbor obsahuje príliš veľa riadkov ({current}). Maximálne povolené: {max}',
    invalidRowFormat: 'Neplatný formát riadku',
    missingColumns: 'Chýbajúce povinné stĺpce (SKU a Množstvo)',
    missingSku: 'Chýbajúce SKU',
    invalidSkuFormat: 'Neplatný formát SKU: "{sku}" (musí zodpovedať vzoru: {pattern})',
    skuTooLong: 'SKU príliš dlhé: "{sku}" (maximum 50 znakov)',
    invalidQuantity: 'Neplatné množstvo: "{quantity}" nie je číslo',
    quantityTooLow: 'Množstvo príliš nízke: {quantity} (minimum: {min})',
    quantityTooHigh: 'Množstvo príliš vysoké: {quantity} (maximum: {max})',
    notesRequired: 'Pole poznámky je povinné',
    noValidData: 'Nenašli sa žiadne platné údaje. Prosím skontrolujte formát súboru.',
    row: 'Riadok {row}: {errors}',
    rowErrors: '...a {count} ďalších chýb',
    duplicateSkuInRows: 'Duplicitné SKU "{sku}" nájdené v riadkoch: {rows}',
    quantityExceedsMax: 'Riadok {row}: Množstvo {quantity} prekračuje maximum povolené ({max})',
    quantityBelowMin: 'Riadok {row}: Množstvo {quantity} je pod minimom požadovaným ({min})',
    // Validation messages
    unsupportedFileFormat: 'Nepodporovaný formát súboru. Prosím nahrajte CSV alebo Excel súbor.',
    csvParsingErrors: 'Nastali chyby pri spracovaní CSV',
    failedToParseFile: 'Nepodarilo sa spracovať súbor',
    failedToParseExcel: 'Nepodarilo sa spracovať Excel súbor',
    failedToReadFile: 'Nepodarilo sa načítať súbor',
    unknownError: 'Nastala neznáma chyba',
    totalRows: 'Celkom riadkov',
    valid: 'Platné',
    invalid: 'Neplatné',
    skipped: 'Preskočené',
    // SKU validation
    skuValidationError: 'Chyba validácie SKU',
    skuValidationFailed: 'Nepodarilo sa overiť SKU. Môžete pokračovať, ale niektoré položky nemusia byť dostupné.',
    skuNotFound: 'SKU nenájdené v databáze',
    skusNotFound: '{count} SKU nenájdených v databáze',
    itemsHaveInsufficientStock: '{count} položiek má nedostatočné zásoby',
    validatingSKUs: 'Overovanie položiek...',
    unvalidatedChanges: 'Máte neoverené zmeny. Prosím overte ich znova pred pridaním do košíka.',
    revalidate: 'Znova overiť',
    validating: 'Overuje sa...',
    validationSuccess: 'Všetky položky sú platné',
    validationComplete: 'Validácia dokončená',
    validationResultSummary: 'Nájdených {errors} chýb, {warnings} upozornení',
    // Table headers
    actions: 'Akcie',
    notes: 'Poznámky',
    // Status filter
    all: 'Všetky',
    hasErrors: 'Má chyby',
    // Selection summary
    selected: 'vybrané',
    errors: 'chyby',
    // Pagination
    page: 'Strana {current} z {total}',
    previous: 'Predchádzajúce',
    next: 'Ďalšie',
    noResults: 'Žiadne výsledky.',
    // Cart integration
    noValidItems: 'Žiadne platné položky',
    allItemsHaveErrors: 'Všetky položky majú chyby validácie. Prosím opravte ich pred pokračovaním.',
    dataLoadingError: 'Chyba načítania dát',
    failedToLoadProductData: 'Nepodarilo sa načítať údaje o produktoch. Skúste to prosím znova.',
    itemsAddedToCart: '{count} položiek pridaných do košíka',
    itemsAddedMessage: 'Pridaných {count} položiek do košíka',
    someSkusNotFound: '{count} SKU sa nepodarilo nájsť.',
    noItemsAdded: 'Žiadne položky neboli pridané',
    couldNotFindProducts: 'Nepodarilo sa nájsť žiadne produkty zodpovedajúce SKU.',
    errorAddingToCart: 'Chyba',
    failedToAddToCart: 'Nepodarilo sa pridať položky do košíka. Skúste to prosím znova.',
    addingToCart: 'Pridávanie do košíka...',
    // File info
    fileSelected: '{name} vybraný na spracovanie',
    fileSize: '{size} bajtov',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Stiahnutie šablóny',
    templateWillBeImplemented: 'Stiahnutie šablóny bude implementované vo fáze 7',
    // Additional validation
    validationFailed: 'Validácia zlyhala',
    // Template download
    templateDownloaded: 'Šablóna úspešne stiahnutá',
    templateDownloadError: 'Nepodarilo sa stiahnuť šablónu',
    // Template content
    sheetName: 'Hromadná objednávka',
    instructionsSheetName: 'Inštrukcie',
    columnDescriptions: 'Popis stĺpcov:',
    columnHeader: 'Stĺpec',
    columnRequired: 'Povinný',
    columnOptional: 'Voliteľný',
    columnDescription: 'Popis',
    templateNotes: 'Poznámky:',
    templateNote1: 'Prvý riadok musí obsahovať hlavičky stĺpcov presne ako je uvedené',
    templateNote2: 'Dáta začínajú od riadku 2',
    templateNote3: 'SKU musí zodpovedať existujúcim kódom produktov v systéme',
    templateNote4: 'Množstvo musí byť kladné celé číslo medzi 1 a 9999',
    templateNote5: 'Maximálne 1000 riadkov povolených na súbor',
    templateNote6: 'Uložiť ako formát .xlsx alebo .csv',
    stockAvailabilityWarning: 'Skutočná dostupnosť zásob bude skontrolovaná na ďalšej stránke pokladne.',
    outOfStock: 'Nie je na sklade',
    insufficientStock: 'Nedostatočné zásoby: {available} k dispozícii, {requested} požadovaných',
  },
  orderExport: {
    export: 'Exportovať objednávku',
    exportOrder: 'Exportovať údaje objednávky',
    exportAsCSV: 'Exportovať ako CSV',
    exportAsExcel: 'Exportovať ako Excel',
    exportForReorder: 'Exportovať pre hromadný import',
    detailed: 'Úplné detaily',
    simpleFormat: 'Formát importu',
  },
};
